<template>
    <MBase
        button-classes="bg-positive-500 disabled:bg-positive-100 text-black border-positive-500 hover:bg-positive-600 focus:bg-positive-600 active:bg-positive-600 hover:border-positive-600 focus:border-positive-600 active:border-positive-600 disabled:cursor-not-allowed disabled:bg-positive-100 disabled:border-positive-100 disabled:text-gray-900"
        :href="href"
        :is-loading="isLoading"
        :is-disabled="isDisabled"
        :is-small="isSmall"
        :is-large="isLarge"
        :icon="icon"
        @click="onClick($event)"
        ><slot
    /></MBase>
</template>

<script>
import MBase from "./base";
export default {
    name: "PositiveButton",
    components: {
        MBase
    },
    extends: MBase,
    methods: {
        onClick(event) {
            this.$emit("click", event);
        }
    }
};
</script>
